jQuery(document).ready(function($) {

  // Dynamic list module
 $('.dynamic .list li').first().addClass('up');
 $('.dynamic .image-wrapper .image').first().addClass('show');
  $(".dynamic .list a").hover(function() {
       let $selected = $(this).parent('li');
         $('.dynamic .list li').not($selected).removeClass('up');  
             $selected.toggleClass('up');
         $('.dynamic .image-wrapper .image').removeClass('show');    
         $('#' + $(this).data('rel')).addClass('show');     
  });
     $('.dynamic .list li').on ('mouseleave',function() {
       $(this).first().addClass('up');
       $('#' + $(this).data('rel')).addClass('show');   
 });


  // Floating button
  
  $('.floating-menu-button .close').click(function() {
        console.log('click');
      $(this).parents('.floating-menu-button').animate({
        right: "-100%"
     });
  });  

  // Bootstrap carousel

  $('#testimonials.carousel').carousel({
    pause: "false"
});


// Navigation

if ($(window).width() > 992) {
$('.dropdown-toggle').one('mouseover', function() {
    let url = $(this).attr('title');
    let text = $(this).text();
    $(this).attr('data-url', url).attr('title',text);
    let data_url = $(this).attr('data-url');
    $(this).attr('href', data_url).removeAttr('data-toggle').removeAttr('data-bs-toggle');
  });
} else {
  $('.dropdown-toggle').each(function() {
    $(this).clone().insertAfter(this).text('').addClass('open-link').toggleClass('expanded').append("<span class='chevron'></span>");
    $(this).removeAttr('data-toggle').removeAttr('data-bs-toggle').removeClass('dropdown-toggle');
    let url = $(this).attr('title');
     let text = $(this).text();
     $(this).attr('data-url', url);
    let data_url = $(this).attr('data-url');
     $(this).attr('href', data_url);
  });
}

// Menu highlight

if ($('.wrapper').hasClass('blog')) {
  $('#main-menu > li').each (function() {
       let $nav_text = $(this).find('a').eq(0).text();
         if ( $nav_text == 'Discover') {  
         $(this).addClass('current-menu-item');
     }
   }); 
  }
});


// My Tympa - Clinic Lookup 

(function($) {
  function expand_height() {
      $('#asl-storelocator .asl-panel-inner').show().height(800);
      $('.map-image').height(1050);
      $('#asl-map-canv').height(1050); 
      $('#asl-storelocator .heading').hide();  
  }

  function reduce_height() {
    $('#asl-storelocator .asl-panel-inner').hide();
    $('.map-image').height(550);
    $('#asl-map-canv').height(550);
    $('#asl-storelocator .heading').show();      
}
if ($(window).width() > 992) {
      $(document).on('change', '#auto-complete-search', function() {
        expand_height();
      });

      $(document).on('change', '.adropdown-menu', function() {
        expand_height();
      });

      $('body').on('click','.asl-clear-btn', function() {
        reduce_height();
      });
}     
})(jQuery);